import { Events } from '../FSM/shared/constants'
import { ERROR_TYPE, ErrorCode } from '../constants'
import { FSMStateType, ServiceSend } from '../types/interface/fsm.interface'

export default (send: ServiceSend, errorCode: ErrorCode, state: FSMStateType): void => {
  return send({ type: Events.ERROR, errorType: ERROR_TYPE[errorCode], state })
}
